<template>
<div class="notice_ui" v-if="tipsBox" @click="closeNotice">
    <div class="notice_box">
        <div class="title"  v-if="datas.showTitle!='F'">{{datas.titleText}}</div>
        <div class="text" v-html="datas.text"></div>
        <div class="tips" v-if="datas.notice=='T'" @click="isTips()"><i class="iconfont" :class="{'iconxuanze1':tips}"></i>不再提醒</div>
        <div class="btn" @click="goLink" v-if="datas.showBtn!='F'">我知道了</div>
        <div class="iconfont iconshanchu1" @click="closeTips"></div>
    </div>
</div>
</template>

<script>
import {
    getStorage,
    setStorage
} from "@/utils/wxuser";
export default {
    props: ["datas"],
    data() {
        return {
            tips: false,
            tipsBox: false
        };
    },
    watch: {
        tipsBox(newVal, oldVal) {
            if (newVal == true) {
                let cssStr = "overflow-y: hidden; height: 100%;";
                document.getElementsByTagName('html')[0].style.cssText += cssStr;
                document.body.style.cssText += cssStr;
            } else {
                let cssStr = "overflow-y: auto; height: auto;";
                document.getElementsByTagName('html')[0].style.cssText += cssStr;
                document.body.style.cssText += cssStr;
            }

        }
    },
    destroyed() {
        let cssStr = "overflow-y: auto; height: auto;";
        document.getElementsByTagName('html')[0].style.cssText += cssStr;
        document.body.style.cssText += cssStr;
    },
    methods: {
        closeNotice() {
            if (this.datas.notice && this.datas.notice != 'T') {
                this.tipsBox = false
            }
        },
        isTips() {
            this.tips = !this.tips
        },
        goLink(){
           if (this.tips) {
                setStorage('notice', this.datas.id)
            }
            if (this.datas.btnLink) {
                window.location.href = this.datas.btnLink
            } else {
                this.tipsBox = !this.tipsBox
            }
        },
        closeTips() {

            if (this.tips) {
                setStorage('notice', this.datas.id)
            }
           this.tipsBox = !this.tipsBox

        }
    },
    mounted() {

        if (getStorage('notice') != this.datas.id) {
            this.tipsBox = true
        }

    },
    computed: {

    }

};
</script>

<style lang="less" >
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.notice_ui {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);

    .notice_box {
        padding: 0.533333rem 0;
        box-sizing: border-box;
        background: #fff;
        border-radius: 0.266667rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 92%;

        .title {
            font-size: 15px;
            text-align: center;
            color: #333333;
        }

        .text {
            margin-top: 0.533333rem;
            font-size: 12px;
            color: #666666;
            line-height: 0.453333rem;
            padding: 0 0.941333rem;
            word-break: break-all;
            overflow-y: scroll;
            max-height: 40vh;
            img{
                max-width: 100%;
            }
        }

        .tips {
            margin-top: 0.453333rem;
            display: flex;
            align-items: center;
            font-size: 12px;
            justify-content: center;

            i {
                border: 1px solid #81c8d8;
                width: 18px;
                height: 18px;
                font-size: 17px;
                box-sizing: border-box;
                color: #81c8d8;
                margin-right: 0.186667rem;

                &.iconxuanze1 {
                    border: 0;
                }
            }
        }

        .btn {
            margin: 0.48rem 0.941333rem 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.16rem;
            font-size: 12px;
            background: #81c8d8;
            height: 1.066667rem;
            color: #fff;
        }
    }

    .iconshanchu1 {
        position: absolute;
        color: #fff;
        font-size: 24px;
        bottom: -1.066667rem;
        left: 50%;
        transform: translateX(-50%);
        
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/notice.vue